import React from "react";

import { Field } from "formik";

import TextField from "../../components/CstmTextField";
import MoneyTextField from "../../components/MoneyTextField";

const FlipFields = () => {
  return (
    <React.Fragment>
      <Field
        name="arv_market_value"
        component={MoneyTextField}
        label="ARV (After Repair Value)"
        required
        formControlStyle={{ style: { marginTop: 15 } }}
      />

      <Field
        name="rehab_amount"
        component={MoneyTextField}
        label="Rehab Amount"
        required
        formControlStyle={{ style: { marginTop: 15 } }}
      />

      <Field
        name="sq_ft_addition"
        label="Sq Ft Addition"
        component={TextField}
        multiline
        required
        formControlStyle={{ style: { marginTop: 15 } }}
      />
    </React.Fragment>
  );
};

export default FlipFields;



// WEBPACK FOOTER //
// ./src/Screens/ExtraPanels/FlipFields.js